/**
 * Server-side leaderboard (ructec portal, Edge Function `spiel-bestenliste`, ructec 2026-10-08): only signed-in users of a
 * company registered on ructec.com take part. Sign-in runs on the portal page /spiel-anmelden, which sends the player back
 * here with a "Spielausweis" in the URL fragment (#ausweis=…, valid 30 days). bauralley.com → live portal, stage and
 * localhost → staging; hosts without a backend show the leaderboard empty and report nothing.
 */
export interface LeaderboardServiceConfig {
  readonly backendByHost: Readonly<Record<string, string>>;
  /** ructec portal of this host – its /spiel-anmelden issues the Spielausweis for the portal's own database. */
  readonly portalByHost: Readonly<Record<string, string>>;
}

export const LEADERBOARD_CONFIG: LeaderboardServiceConfig = {
  backendByHost: {
    // live launch 2026-10-08 (ructec): bauralley.com → live portal database
    'bauralley.com': 'https://macigkxnscddyaytybol.supabase.co/functions/v1/spiel-bestenliste',
    'www.bauralley.com': 'https://macigkxnscddyaytybol.supabase.co/functions/v1/spiel-bestenliste',
    'stage.bauralley.com': 'https://pasmhdxlsqrmomjwbzhz.supabase.co/functions/v1/spiel-bestenliste',
    localhost: 'https://pasmhdxlsqrmomjwbzhz.supabase.co/functions/v1/spiel-bestenliste',
  },
  portalByHost: {
    'stage.bauralley.com': 'https://stage.ructec.com',
    localhost: 'https://stage.ructec.com',
    'bauralley.com': 'https://ructec.com',
    'www.bauralley.com': 'https://ructec.com',
  },
};

/** Leaderboard backend of this host, or null. */
export function leaderboardBackendUrl(config: LeaderboardServiceConfig, hostname: string): string | null {
  return config.backendByHost[hostname] ?? null;
}

/** Sign-in address on the portal that leads back to this game origin (default: ructec.com). */
export function leaderboardLoginUrl(config: LeaderboardServiceConfig, location: { hostname: string; origin: string }): string {
  const portal = config.portalByHost[location.hostname] ?? 'https://ructec.com';
  return `${portal}/spiel-anmelden?ziel=${encodeURIComponent(location.origin)}`;
}
